import React from 'react';
import WalletCard from './WalletCard';
import { SkeletonWalletCard } from './SkeletonWalletCard';

const EmptyBankPlaceholder = () => (
  <div
    className="card border-0 shadow-sm"
    style={{
      minWidth: 420,
      minHeight: 230,
      opacity: 0.65,
      borderRadius: 12,
      background:
        'linear-gradient(135deg, rgba(255,255,255,0.85), rgba(245,247,250,0.85))',
      border: '1px dashed rgba(0,0,0,0.12)',
    }}
  >
    <div className="card-body">
      <div className="d-flex align-items-center mb-2">
        <span
          className="rounded d-inline-flex align-items-center justify-content-center mr-3"
          style={{ width: 40, height: 40, background: '#EEF2F6' }}
        >
          <i className="fa fa-university text-muted" />
        </span>
        <div>
          <div className="text-muted small">Wallet Name</div>
          <div className="font-weight-semibold text-muted">— — —</div>
        </div>
      </div>

      <div className="d-flex justify-content-between mb-2">
        <div>
          <div className="text-muted small">Balance</div>
          <div className="h6 mb-0 text-muted">— — —</div>
        </div>
        <div className="text-right">
          <div className="text-muted small">Status</div>
          <span className="badge badge-light">Not Connected</span>
        </div>
      </div>

      <div className="text-muted small">
        Your wallet will appear here once added.
      </div>
    </div>
  </div>
);

const WalletRow = ({
  isLoading,
  walletListing,
  currency,
  handleNewTransfer,
  handleReconcile,
  handleEditBank,
  handleNewDeposit,
  handleNewWithdraw,
  handleManageBank,
  handleDeleteBank,
  handleStatement,
}) => {
  const hasBanks = Array.isArray(walletListing) && walletListing.length > 0;

  return (
    <div className="card border-0 shadow-sm mb-3">
      <div className="card-body">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="h6 mb-0">Collection Wallets</div>
          <div>
            <button
              className="btn btn-sm btn-outline-primary mr-2"
              onClick={handleNewTransfer}
              disabled={!hasBanks}
              title={!hasBanks ? 'Add a bank account first' : ''}
            >
              <i className="fa fa-random mr-1" />
              New Payment
            </button>
            <button
              className="btn btn-sm btn-primary"
              onClick={handleReconcile}
              disabled={!hasBanks}
            >
              <i className="fa fa-balance-scale mr-1" />
              Reconcile
            </button>
          </div>
        </div>

        {/* Horizontal list */}
        <div
          className="overflow-auto flex-row d-flex trainer-list"
          style={{ gap: 12, paddingBottom: 6 }}
        >
          {/* Loading state */}
          {isLoading && (
            <>
              <div className="col-lg-7 mb-3">
                <SkeletonWalletCard />
              </div>
              <div className="col-lg-7 mb-3">
                <SkeletonWalletCard />
              </div>
            </>
          )}

          {/* Normal state */}
          {hasBanks &&
            walletListing.map((b) => (
              <div className="col-lg-7 mb-1" key={b.bank_id}>
                <WalletCard
                  bank={b}
                  onEdit={handleEditBank}
                  currency={currency}
                  onDeposit={handleNewDeposit}
                  onWithdraw={handleNewWithdraw}
                  onManage={handleManageBank}
                  onDelete={handleDeleteBank}
                  handleStatement={handleStatement}
                />
              </div>
            ))}

          {/* Empty (not loading, no banks) */}
          {walletListing === '404' && (
            <>
              <div className="col-lg-6 mb-3">
                <EmptyBankPlaceholder />
              </div>
             
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletRow;
